import {create} from 'zustand';
import {countStatusProduct, getProductCategories, getProductList} from "../network/api";
import {PRODUCT_STATUS, STATUS_TABS} from "../constants";

const productStore = create((set) => ({
    productData: null,
    categoryData: null,
    statusCount: null,
    clearProductData: () => {
        set({productData: null, categoryData: null, statusCount: null});
    },
    getProducts: async (params) => {
        const response = await getProductList(params);
        set({productData: response.data});
        return response;
    },
    getProductCate: async () => {
        const response = await getProductCategories();
        set({categoryData: response.data});
        return response;
    },
    getStatusCount: async () => {
        const response = await countStatusProduct();
        let total = 0
        if (Object.keys(response?.data).length > 0) {
            total = Object.values(response?.data)?.reduce((sum, value) => sum + value, 0);
        }
        set({
            statusCount: STATUS_TABS.map((item) => {
                if (item?.status === PRODUCT_STATUS.ALL) {
                    return {
                        ...item, count: total
                    }
                }
                return {
                    ...item, count: response?.data?.[item.status] || 0,
                    redSight: item?.status === PRODUCT_STATUS.REJECTED && response?.data?.[item.status] > 0,
                }
            })
        });
        return response
    }
}));

export default productStore;
